import Swal from 'sweetalert2';
import "../../scss/components/_sweetalert.scss";

const SUCCESS_ICON_SVG = `
    <div style="background-color:#22C55E; border-radius:50%; display:flex; align-items:center; justify-content:center; padding:8px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
`;

export const showLoading = () => {
    Swal.fire({
        position: "center",
        icon: "info",
        title: "Processing, please wait...",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        willOpen: () => { Swal.showLoading(); },
        customClass: { popup: 'rounded-popup' },
    });
};

export const hideLoading = () => Swal.close();

export const showConfirm = ({ title, detail }) => {
    return Swal.fire({
      html: `
        <div class="swal-confirm-main">
          <div class="swal-confirm-title">${title}</div>
          <div class="swal-confirm-detail">${detail}</div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonColor: "#2563EB",
      cancelButtonColor: "#F1F5F9",
      cancelButtonText: `<span style="color:#64748B; font-weight:500;">Cancel</span>`,
      confirmButtonText: `<span style="color:#fff; font-weight:600;">Confirm</span>`,
      customClass: { popup: 'swal-confirm-popup' }
    });
  };

export const showSuccess = ({ title }) => {
    return Swal.fire({
        position: "center",
        html: `
            <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
                ${SUCCESS_ICON_SVG}
                <div style="font-size:18px; font-weight:600; color:#1E293B;">${title}</div>
            </div>
        `,
        showConfirmButton: false,
        timer: 1500,
        customClass: { popup: 'rounded-popup' }
    });
};

export const showSuccessDetail = ({ title, detail, timer = 2000, icon = null }) => {
  const iconHtml = icon
      ? `<div style="background-color:#22C55E; border-radius:50%; display:flex; align-items:center; justify-content:center; padding:8px; height:40px; width:40px;">
             <i class="${icon}" style="color:#fff; font-size:24px;"></i>
         </div>`
      : `<div style="background-color:#22C55E; border-radius:50%; display:flex; align-items:center; justify-content:center; padding:8px; height:40px; width:40px;">
             <i class="mdi mdi-undo-variant" style="color:#fff; font-size:24px;"></i>
         </div>`;

  return Swal.fire({
      position: "center",
      html: `
          <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
              ${iconHtml}
              <div style="font-size:18px; font-weight:600; color:#1E293B;">${title}</div>
              ${detail ? `<div style="font-size:14px; color:#64748B;">${detail}</div>` : ''}
          </div>
      `,
      showConfirmButton: false,
      timer: timer,
      customClass: { popup: 'rounded-popup' }
  });
};

// export const showSuccess = ({ title, detail }) => {
//     return Swal.fire({
//         position: "center",
//         html: `
//             <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
//                 ${SUCCESS_ICON_SVG}
//                 <div style="font-size:18px; font-weight:600; color:#1E293B;">${title}</div>
//                 <div style="font-size:14px; color:#64748B;">${detail}</div>
//             </div>
//         `,
//         showConfirmButton: false,
//         timer: 1500,
//         customClass: { popup: 'rounded-popup' }
//     });
// };

const ERROR_ICON_SVG = `
    <div style="background-color:#EF4444; border-radius:50%; display:flex; align-items:center; justify-content:center; padding:8px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
`;

export const showError = (title = "Error! data not saved.") => {
    return Swal.fire({
        position: "center",
        html: `
            <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
                ${ERROR_ICON_SVG}
                <div style="font-size:18px; font-weight:600; color:#1E293B;">${title}</div>
            </div>
        `,
        showConfirmButton: false,
        timer: 1500,
        customClass: { popup: 'rounded-popup' }
    });
};


const DELETE_ICON_SVG = `
  <div style="background-color:#EF4444; border-radius:50%; display:flex; align-items:center; justify-content:center; padding:8px;">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M3 6H5H21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
`;

export const showCancelRequestSuccess = () => {
  return Swal.fire({
    position: "center",
    html: `
      <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
        ${DELETE_ICON_SVG}
        <div style="font-size:18px; font-weight:600; color:#1E293B;">ลบคำขอแล้ว</div>
      </div>
    `,
    showConfirmButton: false,
    timer: 1500,
    customClass: { popup: 'rounded-popup' }
  });
};


export const showSaveSuccess = () => {
    return Swal.fire({
      position: "center",
      html: `
        <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
          ${SUCCESS_ICON_SVG}
          <div style="font-size:18px; font-weight:600; color:#1E293B;">บันทึกการเปลี่ยนแปลง</div>
        </div>
      `,
      showConfirmButton: false,
      timer: 1500,
      customClass: { popup: 'rounded-popup' }
    });
  };

  const CANCEL_ICON_SVG = `
    <div style="background-color:#EF4444; border-radius:50%; display:flex; align-items:center; justify-content:center; padding:8px; height:40px; width:40px;">
        <i class="mdi mdi-close-circle" style="color:#fff; font-size:24px;"></i>
    </div>
`;

export const showCancelDetail = ({ title, detail, timer = 2000 }) => {
    return Swal.fire({
        position: "center",
        html: `
            <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
                ${CANCEL_ICON_SVG}
                <div style="font-size:18px; font-weight:600; color:#1E293B;">${title}</div>
                ${detail ? `<div style="font-size:14px; color:#64748B;">${detail}</div>` : ''}
            </div>
        `,
        showConfirmButton: false,
        timer: timer,
        customClass: { popup: 'rounded-popup' }
    });
};


export const showAdminCancelDetail = ({ title, detail, timer = 2000 }) => {
  return Swal.fire({
      position: "center",
      html: `
          <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
              <i class="mdi mdi-check-circle" style="font-size:48px; color:#64748B;"></i>
              <div style="font-size:18px; font-weight:600; color:#1E293B;">${title}</div>
              ${detail ? `<div style="font-size:14px; color:#64748B;">${detail}</div>` : ''}
          </div>
      `,
      showConfirmButton: false,
      timer: timer,
      customClass: { popup: 'rounded-popup' }
  });
};

export const showDeleteDetail = ({ title, detail, timer = 2000 }) => {
  const iconHtml = `<div style="background-color:#EF4444; border-radius:50%; display:flex; align-items:center; justify-content:center; padding:8px; height:40px; width:40px;">
      <i class="mdi mdi-close-circle" style="color:#fff; font-size:24px;"></i>
  </div>`;
  return Swal.fire({
      position: "center",
      html: `
          <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
              ${iconHtml}
              <div style="font-size:18px; font-weight:600; color:#1E293B;">${title}</div>
              ${detail ? `<div style="font-size:14px; color:#64748B;">${detail}</div>` : ''}
          </div>
      `,
      showConfirmButton: false,
      timer: timer,
      customClass: { popup: 'rounded-popup' }
  });
};